import OutputIcon from '@mui/icons-material/Output';
import { Link } from 'react-router-dom';
import { getExternalUrl } from '../../utils';
import { ExternalToolsRow, ExternalChip } from '../ThreatTable/ThreatExpandedRow.style';

const TOOLS = [
  { label: 'URL Scan', type: 'urlscan' },
  { label: 'Wayback Machine', type: 'archive' },
  { label: 'GSB', type: 'transparencyreport' },
  { label: 'Crt.sh', type: 'crt' },
  { label: 'VirusTotal', type: 'virustotal' },
  { label: 'TIP', type: 'threatintelligenceplatform' },
  { label: 'DNS Checker', type: 'dnschecker' },
] as const;

interface ExpandedExternalToolsProps {
  url: string;
  onLinkClick?: (e: React.MouseEvent) => void;
}

const ExpandedExternalTools = ({ url, onLinkClick }: ExpandedExternalToolsProps) => (
  <ExternalToolsRow>
    {TOOLS.map(tool => (
      <Link
        key={tool.type}
        to={getExternalUrl(tool.type, url)}
        target="_blank"
        onClick={onLinkClick}
        style={{ textDecoration: 'none' }}>
        <ExternalChip
          label={tool.label}
          icon={<OutputIcon sx={{ fontSize: 14 }} />}
          clickable
          size="small"
        />
      </Link>
    ))}
    <Link
      to="https://www.whois.com"
      target="_blank"
      onClick={onLinkClick}
      style={{ textDecoration: 'none' }}>
      <ExternalChip
        label="Whois"
        icon={<OutputIcon sx={{ fontSize: 14 }} />}
        clickable
        size="small"
      />
    </Link>
  </ExternalToolsRow>
);

export default ExpandedExternalTools;
